import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark } from "@code-surfer/themes";
import customTheme from "../../../../../../custom-theme";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  github: github,
  vsDark: vsDark,
  customTheme: customTheme,
  React: React
};